import { render } from "./UserDeletedNotes.vue?vue&type=template&id=1a00c4a2"
import script from "./UserDeletedNotes.vue?vue&type=script&lang=js"
export * from "./UserDeletedNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__